import { render, staticRenderFns } from "./ViewITCR.vue?vue&type=template&id=30df541c"
import script from "./ViewITCR.vue?vue&type=script&lang=js"
export * from "./ViewITCR.vue?vue&type=script&lang=js"
import style0 from "./ViewITCR.vue?vue&type=style&index=0&id=30df541c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports